import { render, staticRenderFns } from "./PlaceOrderB2B.vue?vue&type=template&id=d8abf698&"
import script from "./PlaceOrderB2B.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports